import React from "react";
import { useTranslation } from "react-i18next";
import { Level } from "../../../../../common/level";
import { cutShort } from "../../../../../utils/stringUtil";
import Divider from "../../../../../common/divider/Divider";
import Box from "../../../../../common/box/Box";
import { select } from "../PreviewDocumentsUtils";

function Attachments({ state, url, setSelected }) {
  const { t } = useTranslation();

  return (
    <div className="block">
      <Divider label={t("requests.reviewDocuments.attachments.divider")} />
      {state.attachments.map((attachment, index) => (
        <Box
          key={"detail" + index}
          statusIndicatorPosition="left"
          statusIndicatorColor={attachment.color === "grey" ? "red" : attachment.color}
          className="is-size-5"
        >
          <Level>
            <Level.Side align="left">
              {index + 1}. {cutShort(attachment.label, 120, "...")}
            </Level.Side>
            <Level.Side align="right">
              <Level>
                <Level.Side align="right" className="is-flex">
                  <button
                    onClick={() => select("attachments", index, null, null, setSelected)}
                    /* to={{
                      pathname: `${url}/attachments/${index}`,
                      state: { state },
                    }} */
                    rel="noopener noreferrer"
                    className="button is-pulled-left"
                  >
                    {t("requests.reviewDocuments.attachments.preview")}
                  </button>
                </Level.Side>
              </Level>
            </Level.Side>
          </Level>
        </Box>
      ))}
    </div>
  );
}

export default Attachments;
